// Regra compartilhada pelo servidor, loja e painel, sem dependências de infraestrutura.
export class DescontoFormaPagamento {
  static valideConfiguracao(forma: any): void {
    if(!['GERAL', 'PRODUTOS'].includes(forma.modoDesconto))
      throw new Error('Modo de desconto inválido.');
    if(!Array.isArray(forma.descontosProdutos)) throw new Error('Lista de descontos por produto inválida.');
    const padrao = Number(forma.desconto);
    if(padrao > 99.99 || (forma.possuiDesconto && this.porProduto(forma) &&
      (!Number.isFinite(padrao) || padrao < 0.1 ||
        Math.abs(padrao * 100 - Math.round(padrao * 100)) > 0.000001)))
      throw new Error('O desconto padrão deve estar entre 0,1% e 99,99%, com até duas casas decimais.');
    const ids = new Set<number>();
    forma.descontosProdutos.forEach((regra: any) => {
      const id = Number(regra?.produtoId), percentual = Number(regra?.percentual);
      if(!Number.isSafeInteger(id) || id <= 0 || ids.has(id))
        throw new Error('Produto inválido ou duplicado no desconto.');
      if(regra.percentual === '') regra.percentual = null;
      if(regra.percentual != null &&
        (!Number.isFinite(percentual) || percentual < 0.1 || percentual >= 100 ||
          Math.abs(percentual * 100 - Math.round(percentual * 100)) > 0.000001))
        throw new Error('O desconto do produto deve estar entre 0,1% e 99,99%, com até duas casas decimais.');
      ids.add(id);
    });
  }

  static porProduto(forma: any): boolean {
    return forma?.modoDesconto === 'PRODUTOS';
  }

  static deveExibirDesconto(forma: any, itens: any[]): boolean {
    if(!forma?.possuiDesconto) return false;
    if(!this.porProduto(forma)) return Number(forma.desconto) > 0;
    return (itens || []).some(item => this.percentualDoItem(item, forma) > 0 &&
      this.centavos(Number(item.total || 0) - Number(item.desconto || 0)) > 0);
  }

  private static percentualDoItem(item: any, forma: any): number {
    const produto = item.produto;
    if(!produto || produto.tipo === 'kit' || item.componentesKit?.length ||
      item.brinde === true || produto.brinde === true || produto.ehBrinde === true || item.valorResgatado > 0 ||
      item.sabores?.length > 1) return 0;

    const produtoId = item.sabores?.length === 1 ? item.sabores[0].produto?.id : produto.id;
    const regra = (forma.descontosProdutos || []).find((r: any) => Number(r.produtoId) === Number(produtoId));
    if(!regra) return 0;
    const percentual = Number(regra.percentual != null && regra.percentual !== '' ? regra.percentual : forma.desconto);
    return Number.isFinite(percentual) && percentual >= 0.1 && percentual <= 100 ? percentual : 0;
  }

  static centavos(valor: number): number {
    return Math.max(0, Math.round((Number(valor) || 0) * 100));
  }

  // Recebe e devolve centavos. O resto fica nos primeiros itens com capacidade.
  static distribua(total: number, pesos: number[]): number[] {
    const soma = pesos.reduce((a, b) => a + b, 0);
    const limitado = Math.min(Math.max(0, Math.round(total)), soma);
    if(!soma) return pesos.map(() => 0);
    const valores = pesos.map(peso => Math.floor(limitado * peso / soma));
    let resto = limitado - valores.reduce((a, b) => a + b, 0);
    for(let i = 0; resto > 0; i = (i + 1) % pesos.length) {
      if(valores[i] < pesos[i]) { valores[i]++; resto--; }
    }
    return valores;
  }

  static calcule(itens: any[], forma: any, baseLiquida: number): number {
    if(!forma?.possuiDesconto || !this.porProduto(forma)) return 0;

    const pesos = itens.map(item => this.centavos(Number(item.total || 0) - Number(item.desconto || 0)));
    const bases = this.distribua(this.centavos(baseLiquida), pesos);
    let descontoTotal = 0;
    itens.forEach((item, i) => {
      const percentual = this.percentualDoItem(item, forma);
      if(!percentual || !bases[i]) return;

      const desconto = Math.min(bases[i], Math.round(bases[i] * percentual / 100));
      descontoTotal += desconto;
    });
    return descontoTotal / 100;
  }
}
